import './main.less';
import { actions, selectors } from './';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ElementsForm from './components/form';

const Main = props => (
	<div className="container__content showcase-main">
		<div className="container__content-title clearfix">
			<div className="container__content-title-position">
				<h2 className="title">Elements showcase</h2>
			</div>
		</div>
		<div className="container__content-body">
			<div className="showcase-main__section">
				<ElementsForm {...props} initialValues={props.formInitialValues}/>
			</div>
		</div>
	</div>
);

Main.propTypes = {
	formInitialValues: PropTypes.object
};

export default connect(
	state => ({
		data: selectors.getData(state),
		formInitialValues: selectors.getFormInitial(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/showcase/main.js